import { registerPlugin } from '@capacitor/core';

export interface PendingNativeFile {
  name: string;
  mimeType: string;
  uri: string;
}

export interface ConsumePendingFilesResult {
  files: PendingNativeFile[];
}

export interface IncomingFilesPlugin {
  consumePendingFiles(): Promise<ConsumePendingFilesResult>;
}

export const IncomingFiles = registerPlugin<IncomingFilesPlugin>('IncomingFiles', {
  web: () => import('./incomingFilesWeb').then((module) => new module.IncomingFilesWeb()),
});
